import { SoundChannel } from "./SoundChannel";
import { PAL } from "../platform/PlatformAdapters";
import { URL } from "../net/URL";
import { Browser } from "../utils/Browser";
import { Pool } from "../utils/Pool";
export class HTMLAudioChannel extends SoundChannel {
    get position() {
        if (this._ele)
            return this._ele.currentTime;
        else
            return 0;
    }
    get duration() {
        if (this._ele)
            return this._ele.duration;
        else
            return 0;
    }
    onPlay(url) {
        this._ele = HTMLAudioChannel.elementPool.take();
        Browser.container.appendChild(this._ele);
        this._loaded = true;
        let ele = this._ele;
        ele.onerror = (event) => {
            console.error("HTMLAudioChannel: ", event);
            this.stop();
        };
        ele.onended = () => this.onPlayEnd();
        ele.src = URL.postFormatURL(URL.formatURL(url));
        ele.playbackRate = this.playbackRate;
        ele.currentTime = this.startTime;
        ele.loop = this.loops === 0;
        ele.volume = this._volume;
        ele.muted = this._muted;
        if (!this._paused) {
            if (ele.readyState > 0 && !ele.paused)
                return;
            Promise.resolve().then(() => {
                if (!this._ele)
                    return;
                this._ele.play().catch(e => {
                    if (e.name === "NotAllowedError" && this._isMusic)
                        PAL.media.resumeUntilGotFocus(this);
                    else
                        console.warn(e);
                });
            });
        }
    }
    onPlayAgain() {
        this._ele.currentTime = this.startTime;
        this._ele.play().catch(e => { });
    }
    onStop() {
        this._ele.pause();
        HTMLAudioChannel.elementPool.recover(this._ele);
        this._ele = null;
    }
    onPause() {
        this._ele.pause();
    }
    onResume() {
        if (this._ele.readyState === 0)
            this._ele.load();
        this._ele.play().catch(e => { });
    }
    onVolumeChanged() {
        this._ele.volume = this._volume;
    }
    onMuted() {
        this._ele.muted = this._muted;
    }
}
HTMLAudioChannel.elementPool = Pool.createPool2(() => createAudioElement(), null, ele => resetAudioElement(ele));
function createAudioElement() {
    return Browser.createElement("audio");
}
function resetAudioElement(ele) {
    ele.remove();
    ele.src = "";
    ele.onended = null;
    ele.onerror = null;
    ele.oncanplay = null;
    ele.oncanplaythrough = null;
}
